import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnvelopePigeon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2380_38969)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M19.0073 24.8709C25.9708 25.3452 28.0411 19.9164 28.0411 19.9164C28.0411 19.9164 26.2356 20.8192 21.7217 18.1109C21.0909 17.7317 20.459 17.3164 19.8307 16.8867C28.9439 12.6942 27.1383 2.76367 27.1383 2.76367C27.1383 2.76367 20.8189 5.47201 19.0133 7.27756C17.8662 8.42469 16.8178 12.1959 16.305 13.597C13.9638 12.0563 11.7911 10.8887 9.08279 11.7914C8.13578 12.0484 7.32492 12.6618 6.82007 13.5033C6.31522 14.3447 6.15553 15.3488 6.37446 16.3053L5.47168 19.0137H8.18001",
				stroke: "#00A1A1",
				strokeWidth: 1.9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.92097 19.0137H0.958008V28.0414H15.4025V19.0137H12.5136",
				stroke: "#00A1A1",
				strokeWidth: 1.9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.958008 19.9165L8.18023 24.4304L15.4025 19.9165",
				stroke: "#00A1A1",
				strokeWidth: 1.9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4372 14.4995C10.5265 14.4995 10.6138 14.526 10.688 14.5756C10.7622 14.6252 10.8201 14.6957 10.8543 14.7782C10.8884 14.8606 10.8974 14.9514 10.8799 15.039C10.8625 15.1265 10.8195 15.207 10.7564 15.2701C10.6933 15.3332 10.6129 15.3762 10.5253 15.3936C10.4377 15.411 10.347 15.4021 10.2645 15.3679C10.182 15.3338 10.1115 15.2759 10.0619 15.2017C10.0123 15.1274 9.98584 15.0402 9.98584 14.9509C9.98584 14.8312 10.0334 14.7164 10.118 14.6317C10.2027 14.5471 10.3175 14.4995 10.4372 14.4995",
				stroke: "#00A1A1",
				strokeWidth: 1.9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.6084 23.7056L26.2358 25.333",
				stroke: "#00A1A1",
				strokeWidth: 1.9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.2319 24.8433L23.5274 27.1387",
				stroke: "#00A1A1",
				strokeWidth: 1.9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.6497 11.7227C11.6214 10.1169 11.0157 8.27727 10.8887 6.37467C11.0232 4.44556 11.6444 2.58201 12.6942 0.958008C14.234 2.51543 15.4599 4.35436 16.3053 6.37467",
				stroke: "#00A1A1",
				strokeWidth: 1.9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2380_38969",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 28.8889,
			height: 28.8889,
			fill: "white",
			transform: "translate(0.0551758 0.0551758)"
		})
	}) })]
});
export default SvgEnvelopePigeon;
